module.exports = __webpack_public_path__ + "media/images/blank-56398e76.gif";